import * as React from 'react'

import { Colors } from '@doordash/design-language'
import {
  Breadcrumb,
  CrumbContainer,
  ListItemContainer,
  Separator,
} from './styles'

interface IRoute {
  path: string
  breadcrumb: string
}

type Props = {
  separator?: string
  routes: IRoute[]
}

export class Breadcrumbs extends React.Component<Props, any> {
  public static defaultProps = {
    separator: '>',
  }

  public RenderRoutes = routes => {
    return routes.map(({ path, breadcrumb }, index) => {
      return (
        <ListItemContainer key={index}>
          {index !== routes.length - 1 && (
            <Breadcrumb tag="a" href={path} color={Colors.SystemGrey60}>
              {breadcrumb}
            </Breadcrumb>
          )}
          {index === routes.length - 1 && (
            <Breadcrumb color={Colors.SystemTeal50}>{breadcrumb}</Breadcrumb>
          )}
          <Separator>
            {index === routes.length - 1 ? null : this.props.separator}
          </Separator>
        </ListItemContainer>
      )
    })
  }

  public render() {
    const { routes } = this.props

    return <CrumbContainer>{this.RenderRoutes(routes)}</CrumbContainer>
  }
}

export default Breadcrumbs
